// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-3c487728]{display:none}.expandable[data-v-3c487728]:first-child{padding-top:16px}.expandable__note[data-v-3c487728]{color:var(--c-grey-primary);font-size:.875rem;font-style:italic;font-weight:400;line-height:1.25}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
